import { find, forEach } from 'lodash';

export default [ 'checkout', 'basket', 'order', 'configService', 'validateService', 'promoApiService', 'moneyService', 'voucherApiService', function (checkout, basket, order, configService, validateService, promoApiService, moneyService, voucherApiService) {
  const additionalRequirements = (check) => {
    this.additionalCheck = check;
  };

  const validate = (step) => {
    return basket.promise.then(() => {
      let error = [];
      checkout.error = undefined;
      switch (step) {
      case 'credit':
        checkout.spadayError = [];
        let unavailableSpaDays = this.additionalCheck;
        // Check for options per guest and throw error if not all selected
        for (let guest of basket.contents.guest_details) {
          for (let item of guest.item_details) {
            if (item.item.credit > 0 && !find(item.item_children, { item_type: 'App\\Treatment' }) && !find(unavailableSpaDays, { id: item.id })) {
              if (error.length === 0) {
                error.push('One of your Spa Days has credit but has no treatments selected');
              }
              checkout.spadayError.push(item.id);
            }
          }
        }

        break;
      case 'customise':
        checkout.optionError = false;
        // Check for options per guest and throw error if not all selected

        for (let guest of basket.contents.guest_details) {
          for (let item of guest.item_details) {
            if (checkout.optionError) {
              continue;
            }

            checkout.optionError = validateService.optionError(item, item.requiredOptions);

            if (checkout.optionError) {
              error.push(checkout.optionError);
            }
          }
        }

        break;
      case 'review':
        if (!basket.tcs || basket.contents.cancellation_agreement === false) {
          error.push('You must agree to the terms and conditions before completing your order.');
        }
        break;
      case 'payment': {
        let customerFields = {
          first_name: 'First name',
          last_name: 'Last name',
          phone: 'Phone number',
          email: 'Email address'
        };
        let addressFields = {
          avs_street: 'Street details',
          avs_city: 'City details',
          avs_state: 'State/County details',
          avs_zip: 'Post Code details',
          avs_country: 'Country details'
        };

        if (!order.contents.basket_identity_code) {
          error.push('Order was not generated correctly');
        }

        if (!error.length && !order.contents.customer) {
          error.push('Your details are required');
        }

        forEach(customerFields, (value, key) => {
          if (order.contents && order.contents.customer) {
            if (order.contents.customer.selectedGuest) {
              if (order.contents.customer.selectedGuest.loggedIn) {
                return false;
              }

              if (key === 'first_name' || key === 'last_name') {
                return;
              }
            }

            if (!order.contents.customer[key]) {
              error.push(value + ' is required');
            }
          }
        });
        if (configService.get('gateways').paysafe) {
          forEach(addressFields, (value, key) => {
            if (order.contents && !order.contents[key]) {
              error.push(value + ' are required');
            }
          });
        }

        if (!error.length && order.contents.vouchers.length) {
          for (const voucher of order.contents.vouchers) {
            if (!voucher.code) {
              error.push('One of your vouchers has not been entered correctly.');
              break;
            }
          }
        }
        break;
      }
      }

      if (error.length === 0) {
        return true;
      }

      checkout.error = error;
      checkout.scrollToError();
      return false;
    });
  };

  const validatePromo = order => {
    const currency = moneyService.getCurrencyDetails(configService.get('currency'));
    return promoApiService.validate(order.contents.basket_identity_code, order.contents.promo_details)
      .then(response => {
        if (response && typeof response === 'object') {
          setOrderTotal(response);
          let text = 'Promotional code was successful';
          if (response && response.discount) {
            text += `, discount of ${currency.symbol}${response.discount / currency.magnitude} was applied`;
          }

          return {
            'text': text,
            'class': 'c-promo__feedback--success'
          };
        }

        return failValidateResponse('promotional');
      })
      .catch(() => {
        return failValidateResponse('promotional');
      });
  };

  const validateVoucher = order => {
    const currency = moneyService.getCurrencyDetails(configService.get('currency'));
    return voucherApiService.validate(order.contents.basket_identity_code, order.contents.vouchers[0].code)
      .then(response => {
        if (response && typeof response === 'object') {
          setOrderTotal(response);
          let text = 'Voucher code was successful';
          if (response && response.discount) {
            text += `, discount of ${currency.symbol}${response.discount / currency.magnitude} was applied`;
          }

          return {
            'text': text,
            'class': 'c-promo__feedback--success'
          };
        }

        return failValidateResponse('voucher');
      })
      .catch(() => {
        return failValidateResponse('voucher');
      });
  };

  const failValidateResponse = (type) => {
    setOrderTotal();
    return {
      'text': `Sorry, that ${type} code is not valid`,
      'class': 'c-promo__feedback--fail'
    };
  };

  const setOrderTotal = (response = {}) => {
    order.contents.total = order.contents.original_total;

    if (response && response.discount) {
      order.contents.total -= response.discount;
    }

    if(order.contents.total < 0) {
      order.contents.total = 0;
    }
  };

  return {
    validate,
    validatePromo,
    validateVoucher,
    additionalRequirements
  };
} ];



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/checkout/services/checkout.validation.service.js